import { RootState } from '../store';

export const getAddOnProducts = (state: RootState) =>
  state.registrationAddOns.addOnProducts;

export const getRegistrationCost = (state: RootState) =>
  state.registrationAddOns.registrationCost;

export const getRegistrationType = (state: RootState) =>
  state.registrationAddOns.registrationType;

export const getSelectionsWithErrors = (state: RootState) =>
  state.registrationAddOns.selectionsWithErrors;

export const getTaxRate = (state: RootState) =>
  state.registrationAddOns.taxRate;

export const getUserSelections = (state: RootState) =>
  state.registrationAddOns.userSelections;
